"use client";
import React, { useRef } from "react";
import { motion } from "framer-motion";

interface RevealProps {
  children: React.ReactElement;
  delay?: number;
  duration?: number;
  direction?: "left" | "right" | "top" | "bottom";
  withBlur?: boolean;
  blurAmount?: number;
}

const Reveal: React.FC<RevealProps> = ({
  children,
  delay = 0,
  duration = 1,
  direction = "left",
  withBlur = true,
  blurAmount = 10,
}) => {
  const hasAnimated = useRef(false);

  const clipPaths = {
    left: { hidden: "inset(0 100% 0 0)", visible: "inset(0 0% 0 0)" },
    right: { hidden: "inset(0 0 0 100%)", visible: "inset(0 0 0 0%)" },
    top: { hidden: "inset(100% 0 0 0)", visible: "inset(0% 0 0 0)" },
    bottom: { hidden: "inset(0 0 100% 0)", visible: "inset(0 0 0% 0)" },
  };

  const MotionChild = motion(children.type);

  return (
    <MotionChild
      {...children.props}
      initial={
        !hasAnimated.current
          ? {
              clipPath: clipPaths[direction].hidden,
              filter: withBlur ? `blur(${blurAmount}px)` : undefined,
            }
          : {}
      }
      whileInView={
        !hasAnimated.current
          ? {
              clipPath: clipPaths[direction].visible,
              filter: withBlur ? "blur(0px)" : undefined,
            }
          : {}
      }
      transition={{
        duration,
        delay,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      viewport={{ once: true }}
      onAnimationComplete={() => {
        hasAnimated.current = true;
      }}
    />
  );
};

export default Reveal;
